import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MainTitle from 'base/components/MainTitle/index';
import { createSpace } from 'spaces/store/actions';
import { closeModal } from 'modal/store/actions';
import SpaceForm from './SpaceForm';

const CreateSpaceModal = ({
  name, createSpace, closeModal,
}) => (
  <>
    <MainTitle withSpaceBelow>New Space</MainTitle>

    <SpaceForm
      onSubmit={(space) => {
        createSpace(space);
        closeModal(name);
      }}
    />
  </>
);
CreateSpaceModal.propTypes = {
  name: PropTypes.string.isRequired,
  createSpace: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  createSpace,
  closeModal,
};

export default connect(
  null,
  mapDispatchToProps,
)(CreateSpaceModal);
